import { LibraryCategory } from '@/store/modules/teamlibrary/types'
import { Filters } from '@/utils/filters'
import { Component, Vue } from 'vue-property-decorator'

@Component({})

export default class FiltersMixin extends Vue {
  public formatDate(value: string): string {
    return Filters.formatDate(value)
  }

  public thumbnailURLMap(value: string) {
    return Filters.thumbnailURLMap(value)
  }

  public thumbnailURLMapCustomType(value: string, fileType: string = 'png') {
    return Filters.thumbnailURLMapCustomType(value, fileType)
  }

  public hasThumbnailPlaceHolder(value: string): boolean {
    return Filters.hasThumbnailPlaceHolder(value)
  }

  public arrayToCsvString(values: string[], delimiter: string = ', '): string {
    return Filters.arrayToCsvString(values, delimiter)
  }

  public categoryIndiciesToCsvString(categoryIndicies: number[], categoriesMap: any): string {
    return Filters.categoryIndiciesToCsvString(categoryIndicies, categoriesMap)
  }

  public categoriesArrayToMap(categories: LibraryCategory[]): Map<number, LibraryCategory> {
    return Filters.categoriesArrayToMap(categories)
  }
}
